export function  privacy() {
    return (<div className="container">
        <br/>
        <h2>Privacy Statement</h2>
        <br/>
        <p>Your youtube history is processed in your computer. It is not sent to a server.</p>
    </div>)
}
